import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  helperText: { color: 'red' },
  container: { display: 'flex' },
  inputLabel: { width: '50%' },
  inputDiv: { alignItems: 'center' },
  checkBoxText: { marginTop: theme.spacing(1.25) },
  submitButton: {
    width: '15%',
    marginLeft: 'auto',
  },
  inputBoxStyle: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1px',
  },
  projectDescription: {
    fontSize: '18px',
    paddingLeft: '10px',
    border: '1px solid #d8dde1',
    borderRadius: '10px',
    resize: 'vertical',
  },
  memberUpdateModelTitle: {
    margin: theme.spacing(1, 0),
    color: '#999',
    fontWeight: '600',
    fontSize: '0.9rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
}));
